module.exports = __webpack_public_path__ + "static/media/adminIcon02.31d94583.svg";